export default __webpack_public_path__ + "static/media/Read-Medium_V1100.ae1c7228.woff2";